import { render, staticRenderFns } from "./feedbackSetting.vue?vue&type=template&id=0622046c&scoped=true"
import script from "./feedbackSetting.vue?vue&type=script&lang=js"
export * from "./feedbackSetting.vue?vue&type=script&lang=js"
import style0 from "./feedbackSetting.vue?vue&type=style&index=0&id=0622046c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0622046c",
  null
  
)

export default component.exports